// extracted by mini-css-extract-plugin
module.exports = {"card":"_21fnuaTN","fallbackContainer":"_132nJG-o","image":"jrt5vtnQ","cardTitle":"_2niiQgwV","details":"DoeLtKcz","description":"_19MD4uSK","description--Dark":"_21DukNG4"};